import { useNavigate } from "react-router-dom";
import useAppState from "../../../context/AppContext";
import { APP_RETIREMENT_URLS, ERROR_MESSAGES, FAMILY_SITUATION_MARIE_CODE, FAMILY_SITUATION_PACS_CODE } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import { useForm } from "react-hook-form";
import UploadDocumentTemplate from "../../../components/common-template/UploadDocumentTemplate";
import { IUploadedDoc} from "../../../context/model";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { getRequireREFamilyDocumentTypes } from "../../../utils/dataUtils";
import { getAge } from "../../../utils/utils";



export type InfoFamilyDocFormData = { 
  'FAMILY_RECORD_BOOK': IUploadedDoc[];
  'CHILD_HANDICAP_PROOF' : IUploadedDoc[];
  'PACS': IUploadedDoc[];
  'COMMON_LIVE_PROOF' : IUploadedDoc[];
  'COMMON_ADDRESS_PROOF': IUploadedDoc[];
  'SCHOOL_CERTIFICATE': IUploadedDoc[]
}

export default function REInfoFamilyDocBloc() {

  const navigate = useNavigate();
  const {
      state: {  familyDoc, additionalData, updatedProposition, showModal, proposition },
      dispatch
  } = useAppState();
  const requiredDocuments = getRequireREFamilyDocumentTypes(additionalData, updatedProposition?.familySituationCode ??'');

  const hasChild =additionalData?.hasChild;
  const hasPartner = additionalData?.hasPartner;
  const familySituation = updatedProposition?.familySituationCode 
  const handicapChildrenList =  additionalData?.children?.filter(child => child.hasHandicap === true)
  const handicapChildrenNumber = handicapChildrenList?.length;

  const validationSchema = Yup.object().shape({
    FAMILY_RECORD_BOOK: Yup.array().min( 
      ((hasChild 
       )
       ||(hasPartner && 
         familySituation === FAMILY_SITUATION_MARIE_CODE)
      ) ? 1 : 0, ERROR_MESSAGES.requiredMsg),
    PACS: Yup.array().min(
      (hasPartner  && 
       familySituation === FAMILY_SITUATION_PACS_CODE 
      ) ? 1 : 0
      ,ERROR_MESSAGES.requiredMsg ),
    COMMON_LIVE_PROOF: Yup.array().min(
      (hasPartner  && 
       (familySituation !== FAMILY_SITUATION_PACS_CODE &&
        familySituation !== FAMILY_SITUATION_MARIE_CODE) 
      ) ? 1 : 0,
      ERROR_MESSAGES.requiredMsg ),
    COMMON_ADDRESS_PROOF:  Yup.array().min(
      (hasPartner && 
        (familySituation !== FAMILY_SITUATION_PACS_CODE &&
        familySituation !== FAMILY_SITUATION_MARIE_CODE) 
      ) ? 1 : 0,
      ERROR_MESSAGES.requiredMsg ),
    CHILD_HANDICAP_PROOF: Yup.array().min(
      handicapChildrenNumber !== 0 ? 1 : 0,
      ERROR_MESSAGES.requiredMsg ),
    SCHOOL_CERTIFICATE: Yup.array().min(
      (hasChild && 
      (additionalData?.children?.findIndex(child=> getAge(child.birthDate) >=25) !== -1)
      ) ? 1: 0,
      ERROR_MESSAGES.requiredMsg )
})

  const {
    handleSubmit, 
    setValue, 
    formState: { errors },
  } = useForm<InfoFamilyDocFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      'FAMILY_RECORD_BOOK': familyDoc?.filter(
        doc=> doc.fileType === requiredDocuments?.[0]?.code),
    },
    resolver: yupResolver(validationSchema),
  });

  const onNextAction = async () => {
    const nextUrl = APP_RETIREMENT_URLS.retirementRecapPage;
    dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
    navigate({
        pathname: nextUrl,
        search: `?id=${proposition!.propositionId}`,
    });         
  }

  const onPreviousAction = async () => {
    const url = APP_RETIREMENT_URLS.infoLastEmployeeDocPage;

    dispatch({type: 'BACK_INFO_STEP', path: url});
    navigate({
        pathname: url,
        search: `?id=${proposition!.propositionId}`,
    });         
  }

  return (
    <form style={{width: '100%'}}>
      <div className='page-content bg-blanc shadow-noir p-lg'>
        {requiredDocuments.map((doc, i)=>  {
          const multiple= (handicapChildrenNumber && handicapChildrenNumber>1) ? 's' : '' 
          return (
          <UploadDocumentTemplate
            requiredDocuments={doc}
            errors= {errors}
            isUploadMultipe= {true}
            key={i+1}
            setValue={setValue}
            infoMsg={doc.code==='CHILD_HANDICAP_PROOF' 
              &&handicapChildrenNumber
              ? `(Vous avez déclaré ${handicapChildrenList?.length} enfant${multiple} en situation de handicap. Veuillez nous fournir  ${handicapChildrenList?.length } justificatif${multiple} dans le champs au-dessus.)`
              : undefined}  
          /> )})}
      
          <div className="mt-xl">
            <p className='text fw-medium'>
              <span className='fushia'>(*)</span> Champs obligatoires
            </p>
          </div>
      </div>

      {!showModal &&<StickButtonsBloc 
          showPreviousButton={true} 
          disabledPreviousButton={false} 
          nextAction={handleSubmit(onNextAction)} 
          showNextButton={true} 
          previousAction={onPreviousAction}/>}
    </form>
  )
}